import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface MediaCacheState {
  mediaCache: Record<string, any> // key: model_id, value: media payload
  setMedia: (modelId: string, media: any) => void
  getMedia: (modelId: string) => any | undefined
  removeMedia: (modelId: string) => void // removes a single entry
  clear: () => void                      // clears all cache
}

export const useMediaCacheStore = create<MediaCacheState>()(
  persist(
    (set, get) => ({
      mediaCache: {},
      setMedia: (modelId, media) =>
        set(state => ({
          mediaCache: {
            ...state.mediaCache,
            [modelId]: media
          }
        })),
      getMedia: modelId => get().mediaCache[modelId],
      removeMedia: modelId => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { [modelId]: _removed, ...updated } = get().mediaCache
        set({ mediaCache: updated })
      },
      clear: () => set({ mediaCache: {} }),
    }),
    {
      name: 'media-cache',
      partialize: state => ({
        mediaCache: state.mediaCache
      })
    }
  )
)
